import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "14", "height": "9", "viewBox": "0 0 14 9", "fill": "none" } }, [_c("path", { staticStyle: { "fill-opacity": "1" }, attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M7.74219 0L11.4922 4.5L7.74219 9H10.0853L13.3551 5.07617L13.8353 4.5L13.3551 3.92383L10.0853 0H7.74219Z", "fill": "currentColor" } }), _c("path", { staticStyle: { "stroke-opacity": "1" }, attrs: { "d": "M7.16406 4.5H0.164062", "stroke": "currentColor", "stroke-width": "1.8" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NextIcon = __component__.exports;
export {
  NextIcon as default
};
